const components = {
  Attributes: () => import('@/lakehouse/components/Attributes/Attributes'),
  Attribute: () => import('@/lakehouse/components/Attributes/Attribute'),
  Buckets: () => import('@/lakehouse/components/Buckets/Buckets'),
  Console: () => import('@/lakehouse/components/Console'),
  Explorer: () => import('@/lakehouse/components/Explorer/Explorer'),
  Jobs: () => import('@/lakehouse/components/Jobs/Jobs'),
  JobDetails: () => import('@/lakehouse/components/Jobs/JobDetails'),
  LineageLanding: () => import('@/lakehouse/components/Lineage/LineageLanding'),
  LineageTableView: () => import('@/lakehouse/components/Lineage/LineageTableView'),
  Overview: () => import('@/lakehouse/components/Overview'),
  PolicyTags: () => import('@/lakehouse/components/PolicyTags/PolicyTags'),
  PolicyTagEditor: () => import('@/lakehouse/components/PolicyTags/PolicyTagEditor'),
  RowFilters: () => import('@/lakehouse/components/RowFilters/RowFilters'),
  RedirectTables: () => import('@/lakehouse/components/Tables/Redirect'),
  TableEditor: () => import('@/lakehouse/components/Tables/TableEditor'),
  TablesTables: () => import('@/lakehouse/components/Tables/TablesTables'),
  TablesViews: () => import('@/lakehouse/components/Tables/TablesViews'),
  Datasets: () => import('@/lakehouse/components/Datasets/Datasets'),
  DatasetEditor: () => import('@/lakehouse/components/Datasets/DatasetEditor'),
  Views: () => import('@/lakehouse/components/Views/Views'),
  SqlView: () => import('@/lakehouse/components/Views/SqlView'),
  RouterRedirectDataplantId: () => import('@/shared/RouterRedirectDataplantId')
}

const routes = [
  {
    path: '/',
    name: 'Lakehouse Manager',
    component: components.RouterRedirectDataplantId,
    meta: {
      analytics: { category: 'dashboard' },
      ready: []
    }
  },
  {
    path: '/:dataplantId/',
    name: 'Lakehouse Manager - Overview',
    display_name: 'searchbar.items.lh.overview.display_name',
    description: 'searchbar.items.lh.overview.description',
    searchable: true,
    component: components.Overview,
    meta: {
      analytics: { category: 'dashboard' },
      ready: ['dm_databases', 'dm_logical_objects']
    }
  },
  {
    path: '/:dataplantId/tables',
    name: 'Lakehouse Manager - Tables Redirect',
    display_name: 'searchbar.items.lh.tables.display_name',
    description: 'searchbar.items.lh.tables.description',
    searchable: true,
    component: components.RedirectTables,
    meta: {
      analytics: { category: 'listing' },
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes']
    }
  },
  {
    path: '/:dataplantId/tables/list',
    name: 'Lakehouse Manager - Tables List',
    component: components.TablesTables,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Tables - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_storage_instances']
    }
  },
  {
    path: '/:dataplantId/tables/list/:viewId',
    name: 'Lakehouse Manager - Tables List by repo',
    component: components.TablesTables,
    props: (route) => ({ viewId: route.params.viewId }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Tables - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_storage_instances']
    }
  },
  {
    path: '/:dataplantId/table/:id',
    name: 'Lakehouse Manager - Edit Table',
    component: components.TableEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Table - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes']
    }
  },
  {
    path: '/:dataplantId/tables/views',
    name: 'Lakehouse Manager - Tables Views',
    component: components.TablesViews,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Tables - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_tabs']
    }
  },
  {
    path: '/:dataplantId/tables/views/:viewId',
    name: 'Lakehouse Manager - Tables View',
    component: components.TablesViews,
    props: (route) => ({ viewId: route.params.viewId }),
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Tables - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_tabs']
    }
  },
  {
    path: '/:dataplantId/attributes',
    name: 'Lakehouse Manager - Attributes',
    display_name: 'searchbar.items.lh.attributes.display_name',
    description: 'searchbar.items.lh.attributes.description',
    searchable: true,
    component: components.Attributes,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Attributes - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_attributes']
    }
  },
  {
    path: '/:dataplantId/attribute/:name',
    name: 'Lakehouse Manager - Attribute',
    component: components.Attribute,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Attributes - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_logical_objects', 'dm_logical_attributes', 'dm_virtual_attributes', 'dm_attributes']
    }
  },
  {
    path: '/:dataplantId/datasets',
    name: 'Lakehouse Manager - Datasets',
    display_name: 'searchbar.items.lh.datasets.display_name',
    description: 'searchbar.items.lh.datasets.description',
    searchable: true,
    component: components.Datasets,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Datasets - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/dataset/:id',
    name: 'Lakehouse Manager - Edit Dataset',
    component: components.DatasetEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Dataset - ${parent(route, false)}`,
      ready: ['dm_databases', 'org_session']
    }
  },
  {
    path: '/:dataplantId/views',
    name: 'Lakehouse Manager - Views',
    display_name: 'searchbar.items.lh.views.display_name',
    description: 'searchbar.items.lh.views.description',
    searchable: true,
    component: components.Views,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Views - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_sql_views']
    }
  },
  {
    path: '/:dataplantId/view/:id',
    name: 'Lakehouse Manager - View',
    component: components.SqlView,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Views - ${parent(route, false)}`,
      ready: ['dm_databases', 'dm_sql_views']
    }
  },
  {
    path: '/:dataplantId/policy_tags',
    name: 'Lakehouse Manager - Policy tags',
    display_name: 'searchbar.items.lh.policy_tags.display_name',
    description: 'searchbar.items.lh.policy_tags.description',
    searchable: true,
    component: components.PolicyTags,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Policy Tags - ${parent(route, false)}`,
      ready: ['dm_policy_tags']
    }
  },
  {
    path: '/:dataplantId/policy_tag/:id',
    name: 'Lakehouse Manager - Edit Policy Tags',
    component: components.PolicyTagEditor,
    meta: {
      analytics: { category: 'editor' },
      title: (route, parent) => `Policy Tag - ${parent(route, false)}`,
      ready: ['dm_policy_tags']
    }
  },
  {
    path: '/:dataplantId/row_filters',
    name: 'Lakehouse Manager - Row filters',
    display_name: 'searchbar.items.lh.row_filters.display_name',
    description: 'searchbar.items.lh.row_filters.description',
    searchable: true,
    component: components.RowFilters,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Row filters - ${parent(route, false)}`,
      // `acl` too: the page's own mounted() guard reads the row-filter and
      // dataset/table read rights, and an unloaded right counts as granted.
      ready: ['dm_databases', 'acl']
    }
  },
  {
    path: '/:dataplantId/explorer',
    name: 'Lakehouse Manager - Explorer',
    display_name: 'searchbar.items.lh.explorer.display_name',
    description: 'searchbar.items.lh.explorer.description',
    searchable: true,
    component: components.Explorer,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Explorer - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:dataplantId/explorer/:id',
    name: 'Lakehouse Manager - Explorer View',
    component: components.Explorer,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Explorer - ${parent(route, false)}`,
      ready: []
    }
  },
  {
    path: '/:dataplantId/buckets',
    name: 'Lakehouse Manager - Buckets',
    display_name: 'searchbar.items.lh.buckets.display_name',
    description: 'searchbar.items.lh.buckets.description',
    searchable: true,
    component: components.Buckets,
    props: (route) => ({
      dataplantId: route.params.dataplantId
    }),
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Buckets - ${parent(route, false)}`,
      ready: ['ds_buckets']
    }
  },
  {
    path: '/:dataplantId/buckets/:bucketName',
    name: 'Lakehouse Manager - Bucket',
    component: components.Buckets,
    props: (route) => ({
      bucketName: route.params.bucketName,
      dataplantId: route.params.dataplantId
    }),
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `Buckets - ${parent(route, false)}`,
      ready: ['ds_buckets']
    }
  },
  {
    path: '/:dataplantId/jobs',
    name: 'Lakehouse Manager - Jobs',
    display_name: 'searchbar.items.lh.jobs.display_name',
    description: 'searchbar.items.lh.jobs.description',
    searchable: true,
    component: components.Jobs,
    meta: {
      analytics: { category: 'listing' },
      title: (route, parent) => `Jobs - ${parent(route)}`,
      ready: ['dm_jobs']
    }
  },
  {
    path: '/:dataplantId/job/:id',
    name: 'Lakehouse Manager - Job Details',
    component: components.JobDetails,
    meta: {
      analytics: { category: 'details' },
      title: (route, parent) => `Jobs - ${parent(route)}`,
      ready: ['dm_jobs']
    }
  },
  {
    path: '/:dataplantId/console',
    name: 'Lakehouse Manager - Log Console',
    meta: {
      analytics: { category: 'console' },
      title: (route, parent) => `Logs - ${parent(route)}`,
      fullscreen: true,
      ready: []
    },
    component: components.Console,
    props: (route) => ({ full: true, id: route.query.id, executionId: route.query['execution-type-id'], invert: route.query.invert })
  },
  {
    path: '/:dataplantId/lineage',
    name: 'Lakehouse Manager - Lineage',
    display_name: 'searchbar.items.lh.lineage.display_name',
    description: 'searchbar.items.lh.lineage.description',
    searchable: true,
    component: components.LineageLanding,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Lineage - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/lineage/tables/:id',
    name: 'Lakehouse Manager - Lineage Table',
    component: components.LineageTableView,
    meta: {
      analytics: { category: 'exploration' },
      title: (route, parent) => `Lineage - ${parent(route, false)}`,
      ready: ['dm_databases']
    }
  },
  {
    path: '/:dataplantId/:pathMatch(.*)',
    redirect: { name: 'Lakehouse Manager - Overview' }
  }
]

export const basePath = 'lakehouse/'
export default routes
